import CommingSoon from "../../../../../../Components/Common/CommingSoon/CommingSoon";

function EmailSettings() {
  return <CommingSoon />;
}

export default EmailSettings;
